<router-outlet (activate)="onActivate()"></router-outlet>
<ggi-journey-modal-are-you-sure-handler></ggi-journey-modal-are-you-sure-handler>
<ggi-journey-toast [timeOut]="5"></ggi-journey-toast>
<ggi-journey-modal-success></ggi-journey-modal-success>
<ggi-journey-loader></ggi-journey-loader>
